import type { SimulationFinishedEventPayload } from '~/types/analytics'
import { useAnalytics } from '~/composables/analytics/useAnalytics'

export function useTrackSimulationFinished() {
  const { trackEvent } = useAnalytics()

  function trackSimulationFinished(payload: SimulationFinishedEventPayload) {
    trackEvent('simulation_finished', { ...payload })
  }

  return { trackSimulationFinished }
}
